import Flickity from '../../build/webpack/node_modules/flickity';

window.postSlider = () => {
    return {
        slider: null,
        sliderContainer: null,
        sliderOptions: {},
        visible: false,
        currentSlide: 0,
        sliderEnd: false,

        initSlider(elem, mobDisable = false) {
            this.sliderContainer = elem;

            let defaults = {
                cellAlign: 'center',
                contain: true,
                pageDots: false,
                freeScroll: false,
                prevNextButtons: false,
                on: {
                    ready: () => {
                        this.equalizeSlideHeights(); // Call to set uniform heights
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'));
                        }, 500);
                    },
                }
            };

            this.sliderOptions = pegasus.extend(defaults, {});

            if (window.outerWidth < 768 && mobDisable) {
                if (this.slider !== null) {
                    this.slider.destroy();
                    this.slider = null;
                }
            } else {
                this.slider = new Flickity(this.sliderContainer, this.sliderOptions);
                this.eventListeners(mobDisable);
            }

            // Handle resize events
            pegasus.onResizeFinished(() => {
                this.slider.resize();
                this.equalizeSlideHeights(); // Adjust heights on resize
            });
        },

        eventListeners(mobDisable) {
            this.slider.on('change', slide => {
                this.currentSlide = slide;
            });
            this.slider.on('scroll', e => {
                this.sliderEnd = e.toFixed(2) >= 1;
            });
        },

        equalizeSlideHeights() {
            const slides = this.sliderContainer.querySelectorAll('.Post__Grid-slide');
            let maxHeight = 0;

            // Reset heights before calculating
            slides.forEach(slide => {
                slide.style.height = 'auto'; // Reset to auto to get natural height
            });

            // Find the maximum height
            slides.forEach(slide => {
                const height = slide.offsetHeight; // Get the height of each slide
                if (height > maxHeight) {
                    maxHeight = height; // Update max height if current slide is taller
                }
            });

            // Set all slides to the maximum height
            slides.forEach(slide => {
                slide.style.height = `${maxHeight}px`; // Set height to max height
            });
        },
    }
}
